/**
 * 9-oct-2026 — la clave por cambiar (temporal o vencida) la hace cumplir el SERVIDOR: con ella el token solo sirve
 * para ver quién es, cambiarla y salir, y todo lo demás responde 403 con `codigo: "cambio_de_clave_requerido"`.
 * Es 403 y no 401 a propósito: la sesión vale (un 401 manda al login y sería un bucle).
 *
 * Si le pasa a una sesión abierta (la clave venció con la app en uso), `api.js` avisa con el evento
 * `EVENTO_CLAVE_REQUERIDA` y `AuthContext` vuelve a preguntar quién es: la pantalla de cambio aparece sola.
 */
export const CODIGO_CLAVE_REQUERIDA = "cambio_de_clave_requerido";
export const EVENTO_CLAVE_REQUERIDA = "qb:clave-requerida";

/** PURA. ¿Este error es el 403 «tenés que cambiar la clave»? */
export function esCambioDeClaveRequerido(err) {
  const r = err?.response;
  return r?.status === 403 && r?.data?.detail?.codigo === CODIGO_CLAVE_REQUERIDA;
}

/** PURA. ¿La persona tiene que cambiar la clave antes de usar la app? Y por qué. */
export function motivoDeCambio(user) {
  if (!user) return null;
  if (user.debe_cambiar_password) return "temporal";
  if (user.clave_vencida) return "vencida";
  return null;
}

/** PURA. El texto del aviso de los últimos días, o null si no hay nada que avisar. */
export function textoClavePorVencer(user) {
  const d = user?.clave_vence_en_dias;
  if (d == null || d <= 0 || motivoDeCambio(user)) return null;
  return d === 1 ? "Tu contraseña vence mañana." : `Tu contraseña vence en ${d} días.`;
}
